import { useTranslate } from 'common/src/util/dependencies/dependencies';
import * as React from 'react';
import { UpcomingRoleFormBox } from './roleFormBox';

export const DelegationsBox = () => {
    const translate = useTranslate();

    return (
        <UpcomingRoleFormBox
            subtitle={translate('permissions_rel_23398')}
            title={translate('d_l_gations_78318')}
        />
    );
};
